import axios from "axios";
import API_URL from "../config/apiConfig";

const restaurantHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

export const getRestaurantByMenuLink = (menuLink) =>
  axios.get(`${API_URL}/api/menus/public/${menuLink}`).then(({ data }) => data.restaurant);

export const submitReview = (review) => axios.post(`${API_URL}/api/reviews`, review);

export const getAllReviews = (restaurantId) =>
  axios
    .get(`${API_URL}/api/reviews/${restaurantId}/all`, { headers: restaurantHeaders() })
    .then(({ data }) => data.reviews);

export const updateReviewStatus = (reviewId, status) =>
  axios.patch(`${API_URL}/api/reviews/${reviewId}/status`, { status }, { headers: restaurantHeaders() });
